/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ qty: NonNullable<unknown> }} Stock_Out_Material_Lot_Available_ShortInputs */

const vi_stock_out_material_lot_available_short = /** @type {(inputs: Stock_Out_Material_Lot_Available_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`còn ${i?.qty}`)
};

/**

* @param {Stock_Out_Material_Lot_Available_ShortInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stock_out_material_lot_available_short = /** @type {((inputs: Stock_Out_Material_Lot_Available_ShortInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stock_Out_Material_Lot_Available_ShortInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stock_out_material_lot_available_short(inputs)
});